import {
  Button,
  createMuiTheme,
  Tooltip,
  Card as CardMaterial,
  CardMedia,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  InsertDriveFile,
  Launch,
  PhotoLibrary,
  RateReview,
  VerifiedUser,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import { getArtists } from "../../../../api/artist";
import {
  changeSupplierArtwork,
  changeStatusArtwork,
  getArtworkById,
} from "../../../../api/artwork";
import { getArtworkTypes } from "../../../../api/artworkType";
import { getCountries } from "../../../../api/country";
import { getSuppliers } from "../../../../api/supplier";
import { alertError, alertSuccess } from "../../../../utils/logger";
import CommentDialog from "../../../components/dialogs/CommentDialog";
import FilePickerDialog from "../../../components/dialogs/FilePickerDialog";
import ImageCarouselDialog from "../../../components/dialogs/ImageCarouselDialog";
import ImagePickerDialog from "../../../components/dialogs/ImagePickerDialog";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import ItemCountBadge from "../../../components/ItemCountBadge";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import Table, {
  buttonsStyle,
  getCurrentTablePage,
  substringFormatter,
} from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { LOGS } from "../../../../utils/constants";
import { postLog } from "../../../../api/log";
import MyCarousel from "../../../components/carousel/MyCarousel";
import { CreatePDF } from "../../../components/modal/CreatePDF";
import { getNameOwner, getNameSupplier } from "../../../../utils/helpers";
import { getDivisas } from "../../../../api/divisa";
import { getOwners } from "../../../../api/owner";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

export function getEmptyArtwork() {
  return {
    title: "",
    artworkType: "",
    artist: null,
    size: null,
    technique: null,
    year: null,
    imageURL: null,
    conservationStatus: null,
    signature: null,
    subject: null,
    originCountry: null,
    currentLocation: null,
    provenance: null,
    artworkSuppliers: [],
    artworkOwners: [],
    imagesURLs: [],
    filesURLs: [],
    videosURLs: [],
  };
}

export default function ViewArtworksPage() {
  const [artwork, setArtwork] = useState(getEmptyArtwork());

  const [artists, setArtists] = useState([]);
  const [artworkTypes, setArtworkTypes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [owners, setOwners] = useState([]);
  const [countries, setCountries] = useState([]);

  const [selectedArtworkSupplier, setSelectedArtworkSupplier] = useState(null);
  const [selectedArtworkOwner, setSelectedArtworkOwner] = useState(null);

  const [carouselImages, setCarouselImages] = useState([]);
  const [openCarouselDialog, setOpenCarouselDialog] = useState(false);

  const [selectedOwner, setSelectedOwner] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openImagePickerDialog, setOpenImagePickerDialog] = useState(false);
  const [openFilePickerDialog, setOpenFilePickerDialog] = useState(false);
  const [openCreatePDF, setOpenCreatePDF] = useState(false);
  const [divisas, setDivisas] = useState([]);
  const [divisa, setDivisa] = useState({});

  const [refreshTable, setRefreshTable] = useState(false);

  const [refresh, setRefresh] = useState(null);

  const artworkId = useParams().id;
  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  function buttonFormatter(cell, suppliers) {
    const elem = suppliers?.find((x) => x.supplier === cell);

    return (
      <>
        <Tooltip title={"comments"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenCommentDialog(1);
              setSelectedArtworkSupplier(elem);
            }}
          >
            {<RateReview />}
            {elem?.comments && <ItemCountBadge howMany={1} />}
          </Button>
        </Tooltip>
        <Tooltip title={"Images"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenImagePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <PhotoLibrary />
            {(elem?.imagesURLs?.length > 0 || elem?.images?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip title={"Documentation"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenFilePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <InsertDriveFile />
            {(elem?.filesURLs?.length > 0 || elem?.files?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.filesURLs?.length || 0) + (elem?.files?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip title={"See supplier"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push("/suppliers/" + elem?.supplier + "/edit");
            }}
          >
            <Launch />
          </Button>
        </Tooltip>
        <Tooltip title={"Supplier"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenConfirmDialog(2);
              setSelectedOwner(cell);
            }}
          >
            {elem?.ss ? (
              <VerifiedUser style={{ color: "green" }} />
            ) : (
              <VerifiedUser style={{ color: "red" }} />
            )}
          </Button>
        </Tooltip>
      </>
    );
  }
  function buttonFormatterOwner(cell, owners) {
    const elem = owners?.find((x) => x.owner === cell);

    return (
      <>
        <Tooltip title={"comments"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenCommentDialog(2);
              setSelectedArtworkOwner(elem);
            }}
          >
            {<RateReview />}
            {elem?.comments && <ItemCountBadge howMany={1} />}
          </Button>
        </Tooltip>
        {/* <Tooltip title={"Images"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenImagePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <PhotoLibrary />
            {(elem?.imagesURLs?.length > 0 || elem?.images?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.imagesURLs?.length || 0) + (elem?.images?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip>
        <Tooltip title={"Documentation"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setOpenFilePickerDialog(true);
              setSelectedArtworkSupplier(elem);
            }}
          >
            <InsertDriveFile />
            {(elem?.filesURLs?.length > 0 || elem?.files?.length > 0) && (
              <ItemCountBadge
                howMany={
                  (elem?.filesURLs?.length || 0) + (elem?.files?.length || 0)
                }
              />
            )}
          </Button>
        </Tooltip> */}
        <Tooltip title={"See owner"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push("/owners/" + elem?.owner + "/edit");
            }}
          >
            <Launch />
          </Button>
        </Tooltip>
      </>
    );
  }

  useEffect(() => {
    setRefreshTable(false);
  }, [refreshTable]);

  useEffect(() => {
    getDivisas().then((res) => {
      setDivisas(res.data);
      setDivisa(res.data.find((x) => x.default));
    });
    getArtworkById(artworkId)
      .then((res) => {
        if (res.status === 200) {
          setArtwork(res.data);
          disableLoadingData();
          setRefreshTable(true);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artwork.",
        });
        handleBack();
      });
    getArtists()
      .then((res) => {
        if (res.status === 200) {
          setArtists(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artists.",
        });
        handleBack();
      });
    getArtworkTypes()
      .then((res) => {
        if (res.status === 200) {
          setArtworkTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get artwork types",
        });
        handleBack();
      });
    getOwners()
      .then((res) => {
        if (res.status === 200) {
          setOwners(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get owners.",
        });
        handleBack();
      });
    getSuppliers()
      .then((res) => {
        if (res.status === 200) {
          setSuppliers(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get suppliers.",
        });
        handleBack();
      });
    getCountries()
      .then((res) => {
        if (res.status === 200) {
          setCountries(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get countries.",
        });
        handleBack();
      });
    if (!artworkId) {
      disableLoadingData();
      return;
    }
  }, [artworkId, refresh, disableLoadingData, history]);

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  const handleBack = () => {
    const prevTablePage = location?.state?.page;

    history.push(`/artworks${prevTablePage ? "?page=" + prevTablePage : ""}`);
  };

  const handleChange = (element) => (event) => {
    setArtwork({ ...artwork, [element]: event.target.value });
  };

  function getArtworkSupplierData(artworkSuppliers) {
    let data = [];
    for (let i = 0; i < artworkSuppliers?.length; ++i) {
      const elem = {};
      const artworkSupplier = artworkSuppliers[i];

      elem.fullName = suppliers?.find(
        (x) => x._id === artworkSupplier?.supplier
      )?.fullName;
      elem.comments = artworkSupplier?.comments;
      elem.id = artworkSupplier?.supplier;

      data = data.concat(elem);
    }
    return data;
  }

  const artworkSuppliersColumns = (artworkSuppliers) => [
    { dataField: "id", text: "", formatter: imageFormatter },
    { dataField: "fullName", text: "Full Name", sort: true },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: substringFormatter,
    },
    {
      dataField: "id",
      text: "",
      formatter: (cell) => buttonFormatter(cell, artworkSuppliers),
    },
  ];

  function getArtworkOwnerData(artworkOwners) {
    let data = [];
    for (let i = 0; i < artworkOwners?.length; ++i) {
      const elem = {};
      const artworkOwner = artworkOwners[i];

      elem.fullName = owners?.find(
        (x) => x._id === artworkOwner?.owner
      )?.fullName;
      elem.comments = artworkOwner?.comments;
      elem.id = artworkOwner?.owner;

      data = data.concat(elem);
    }
    return data;
  }

  const artworkOwnersColumns = (artworkOwners) => [
    { dataField: "fullName", text: "Full Name", sort: true },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: substringFormatter,
    },
    {
      dataField: "id",
      text: "",
      formatter: (cell) => buttonFormatterOwner(cell, artworkOwners),
    },
  ];

  function imageFormatter(cell) {
    const elem = artwork.artworkSuppliers?.find((x) => x.supplier === cell);

    const images = (elem.imagesURLs || [])?.concat(elem?.images || []);

    return images && images?.length > 0 ? (
      <img
        src={
          typeof images[0] === "string"
            ? SERVER_URL + "/" + images[0]
            : URL.createObjectURL(images[0])
        }
        alt="artwork"
        style={{ width: "50px", cursor: "zoom-in" }}
        onClick={() => {
          setCarouselImages(images);
          setOpenCarouselDialog(true);
        }}
      />
    ) : (
      <div />
    );
  }

  function imageFormatterOwner(cell) {
    const elem = artwork.artworkOwners?.find((x) => x.owner === cell);

    const images = (elem.imagesURLs || [])?.concat(elem?.images || []);

    return images && images?.length > 0 ? (
      <img
        src={
          typeof images[0] === "string"
            ? SERVER_URL + "/" + images[0]
            : URL.createObjectURL(images[0])
        }
        alt="artwork"
        style={{ width: "50px", cursor: "zoom-in" }}
        onClick={() => {
          setCarouselImages(images);
          setOpenCarouselDialog(true);
        }}
      />
    ) : (
      <div />
    );
  }

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="View artwork">
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-secondary mr-3"
                onClick={() => {
                  setOpenCreatePDF(true);
                }}
              >
                Download
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  history.push({
                    pathname: `/artworks/${artworkId}/edit`,
                    state: {
                      page: getCurrentTablePage(location),
                    },
                  });
                }}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-danger ml-3"
                onClick={() => {
                  setOpenConfirmDialog(1);
                }}
              >
                Delete
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-4">
                <CardMaterial>
                  <CardMedia
                    component="img"
                    alt="Artwork"
                    image={`${SERVER_URL}/${artwork.imageURL}`}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "auto",
                      maxHeight: "400px",
                    }}
                  />
                </CardMaterial>
              </div>
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6">
                    <strong>Artist</strong>
                    <p>
                      {artists?.find((x) => x._id === artwork?.artist)
                        ?.fullName || "---"}
                    </p>

                    <strong>Title</strong>
                    <p>{artwork?.title || "---"}</p>

                    <strong>Year</strong>
                    <p>{artwork?.year || "---"}</p>

                    <strong>Size</strong>
                    <p>{artwork?.size || "---"}</p>

                    <strong>Technique</strong>
                    <p>{artwork?.technique || "---"}</p>

                    <strong>Signature</strong>
                    <p>{artwork?.signature || "---"}</p>

                    <strong>Catalogued</strong>
                    <p>{artwork?.catalogued}</p>

                    <strong>Certified</strong>
                    <p>{artwork?.certified}</p>
                  </div>

                  {/* Right Column for Text Fields */}
                  <div className="col-md-6">
                    <strong>Color</strong>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: artwork?.color || "transparent",
                        borderRadius: "50%",
                      }}
                    />

                    <strong>Price</strong>
                    <p>{artwork?.price || "---"} </p>

                    <strong>Owner</strong>
                    <p>
                      {getNameOwner(owners, artwork?.artworkOwners) || "---"}
                    </p>

                    <strong>Supplier</strong>
                    <p>
                      {getNameSupplier(suppliers, artwork?.artworkSuppliers) ||
                        "---"}
                    </p>

                    <strong>Recent Auctions</strong>
                    <p>{artwork?.recentAuctions || "---"}</p>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <strong>Notas</strong>
            <Typography
              variant="body1"
              sx={{
                whiteSpace: "pre-line",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "16.5px 14px",
                minHeight: "94px",
              }}
              dangerouslySetInnerHTML={{
                __html: (artwork.provenance || "—").replace(/\n/g, "<br>"),
              }}
            />
            {artwork?.imagesURLs && artwork?.imagesURLs.length > 0 && (
              <div className="d-flex">
                <div className="col-12">
                  <MyCarousel
                    lista={artwork?.imagesURLs}
                    nameFile={"images.zip"}
                  />
                </div>
              </div>
            )}
            {artwork?.videosURLs && artwork?.videosURLs.length > 0 && (
              <div className="d-flex">
                <div className="col-md-12">
                  <MyCarousel
                    lista={artwork?.videosURLs}
                    nameFile={"videos.zip"}
                  />
                </div>
              </div>
            )}
            {artwork?.filesURLs && artwork?.filesURLs.length > 0 && (
              <div className="d-flex">
                <div className="col-md-12">
                  <MyCarousel
                    lista={artwork?.filesURLs}
                    nameFile={"files.zip"}
                    carruselDocs={true}
                  />
                </div>
              </div>
            )}
          </CardBody>
          <CardHeader title="Suppliers" sticky={false}></CardHeader>
          <CardBody>
            {artwork?.artworkSuppliers?.length > 0 && !refreshTable && (
              <Table
                data={getArtworkSupplierData(artwork?.artworkSuppliers)}
                columns={artworkSuppliersColumns(artwork?.artworkSuppliers)}
              />
            )}
          </CardBody>

          <CardHeader title="Owners" sticky={false}></CardHeader>
          <CardBody>
            {artwork?.artworkOwners?.length > 0 && !refreshTable && (
              <Table
                data={getArtworkOwnerData(artwork?.artworkOwners)}
                columns={artworkOwnersColumns(artwork?.artworkOwners)}
              />
            )}
          </CardBody>
        </Card>
        <Button onClick={handleBack} variant="outlined">
          Back
        </Button>
        <CommentDialog
          title={"Additional Comments"}
          open={openCommentDialog === 1}
          setOpen={setOpenCommentDialog}
          data={selectedArtworkSupplier?.comments}
          editable={false}
        />
        <CommentDialog
          title={"Additional Comments"}
          open={openCommentDialog === 2}
          setOpen={setOpenCommentDialog}
          data={selectedArtworkOwner?.comments}
          editable={false}
        />
        <ImagePickerDialog
          title={"Images"}
          open={openImagePickerDialog}
          setOpen={setOpenImagePickerDialog}
          data={[
            ...(selectedArtworkSupplier?.imagesURLs ?? []),
            ...(selectedArtworkSupplier?.images ?? []),
          ]}
          editable={false}
        />
        <FilePickerDialog
          title={"Archivos"}
          open={openFilePickerDialog}
          setOpen={setOpenFilePickerDialog}
          data={[
            ...(selectedArtworkSupplier?.filesURLs ?? []),
            ...(selectedArtworkSupplier?.files ?? []),
          ]}
          editable={false}
        />
        <ImageCarouselDialog
          open={openCarouselDialog}
          setOpen={setOpenCarouselDialog}
          images={carouselImages}
        />
        <ConfirmDialog
          title={"Are you sure you want to delete this artwork?"}
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeStatusArtwork(artworkId, true)
              .then((res) => {
                if (res.status === 200) {
                  postLog(
                    loggedUser,
                    LOGS.FIELDS.ARTWORKS,
                    `${LOGS.ACTIONS.DELETE}-${artwork?.title}`
                  );
                  alertSuccess({
                    title: "Deleted!",
                    customMessage: "Artwork deleted successfully.",
                  });
                  history.push({
                    pathname: `/artworks/`,
                    state: {
                      page: getCurrentTablePage(location),
                    },
                  });
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "Could not delete artwork.",
                });
              });
          }}
        />
        <ConfirmDialog
          title={"Are you sure you want to select this supplier?"}
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeSupplierArtwork(artworkId, selectedOwner)
              .then((res) => {
                if (res.status === 200) {
                  postLog(
                    loggedUser,
                    LOGS.FIELDS.ARTWORKS,
                    `${LOGS.ACTIONS.OWNER}-${artwork?.title}`
                  );
                  alertSuccess({
                    title: "Changed!",
                    customMessage: "Supplier Changed successfully.",
                  });
                  setRefresh(true);
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "Could not change supplier.",
                });
              });
          }}
        />

        <CreatePDF
          isOpen={openCreatePDF}
          setIsOpen={setOpenCreatePDF}
          artwork={artwork}
          artists={artists}
          suppliers={suppliers}
          owners={owners}
          divisas={divisas}
        />
      </>
    );
}
